module.exports = __webpack_public_path__ + "static/media/post-group.8363a433.svg";